<template>
  <div>
    <MobileNav class="lg:hidden" />
    <DesktopNav class="hidden lg:block" />
  </div>
</template>

<script>
import MobileNav from './mobile';
import DesktopNav from './desktop';

export default {
  components: {
    MobileNav,
    DesktopNav,
  },

  inject: ['categories'],

  provide() {
    return {
      links: this.links,
    };
  },

  computed: {
    links() {
      const links = {
        templates: {
          link: null,
          text: 'Video Templates',
          children: [
            {
              link: '/browse/after-effects-templates/',
              text: 'Adobe After Effects',
            },
            {
              link: '/browse/premiere-pro-templates/',
              text: 'Adobe Premiere Pro',
            },
            {
              link: '/browse/motion-graphics-templates/',
              text: 'MOGRT',
            },
            {
              link: '/browse/final-cut-pro-templates/',
              text: 'Final Cut Pro',
            },
            {
              link: '/browse/davinci-resolve-templates/',
              text: 'DaVinci Resolve',
            },
            {
              link: '/browse/premiere-rush-templates/',
              text: 'Adobe Premiere Rush',
            },
          ],
        },
        presets: {
          link: null,
          text: 'Presets',
          children: [
            {
              link: '/browse/after-effects-presets/',
              text: 'Adobe After Effects',
            },
            {
              link: '/browse/premiere-pro-presets/',
              text: 'Adobe Premiere Pro',
            },
            {
              link: '/browse/davinci-resolve-macros/',
              text: 'DaVinci Resolve Macros',
            },
          ],
        },
        'motion-graphic': {
          link: '/browse/stock-motion-graphics/',
          text: 'Motion Graphics',
        },
        luts: {
          link: '/browse/luts/',
          text: 'LUTs',
        },
        footage: {
          link: '/browse/stock-video/',
          text: 'Footage',
        },
        voiceover: {
          link: '/browse/voice-over/',
          text: 'Voiceover',
          icon: 'stars',
        },
        music: {
          link: '/browse/royalty-free-music/',
          text: 'Music',
        },
        'sound-effects': {
          link: '/browse/sound-effects/',
          text: 'Sound Effects',
        },
        graphics: {
          link: '/browse/graphics/',
          text: 'Graphics',
        },
        photos: {
          link: '/browse/stock-photos/',
          text: 'Photos',
        },
        plugins: {
          link: '/plugins/',
          text: 'Plugins',
        },
        tools: {
          link: null,
          text: 'Tools',
          hideInDesktop: true,
          children: [
            {
              link: '/integrations/adobe/',
              text: 'Extension',
            },
          ],
        },
        learn: {
          link: '/learn/',
          text: 'Blog',
          openInNewTab: true,
          hideInDesktop: true,
        },
      };

      if (this.$store.getters.userType !== 'paid') {
        links.pricing = {
          link: '/pricing/',
          text: 'Pricing',
          hideInDesktop: true,
          icon: 'fa-solid fa-gift',
        };
      }
      links.business = {
        link: '/business/',
        text: 'Business',
        hideInDesktop: true,
      };
      return links;
    },
  },
};
</script>
